// entry.js
// Webpack entry point. Rewritten to reflect the app's real, current file
// layout (the previous version pointed at a pre-refactor folder structure
// and would not build). This file has no logic of its own beyond requiring
// app.js first (module + CONFIG + routes + run blocks) and then every
// controller/service/directive that used to be loaded as a loose <script>
// tag in index.html.
//
// Two stale references from index.html were fixed while porting this list:
//   - DatasourceConflictDialogController.js now points at its real location
//     under edit-datasource/conflict/ (index.html was missing that folder).
//   - user-management-controller.js was dropped: no such file exists in the
//     repo and nothing references a controller that would come from it —
//     UsersRolesDialogController (usersDialogController.js) is what's
//     actually used for the user management dialog.

require('./app.js');

console.log('bizmetryApp bundle loaded');

require('./common/dialog/standard-dialog.js');
require('./common/ConfigurationService.js');
require('./common/LiveChartViewport.js');
require('./common/PlatformInfoService.js');
require('./common/components/ui-security-reactive/permissions.constants.js');
require('./common/components/ui-security-reactive/PermissionService.js');
require('./common/components/ui-security-reactive/bmRequires.directive.js');
require('./common/components/ui-security-reactive/lifecycle-permissions.js');
require('./common/components/stepper/bmStepper.js');
require('./common/components/loadingSpinner/bmLoadingIndicator.js');
require('./common/components/loadingSpinner/LoadingHTTPInterceptor.js');
require('./common/components/loadingSpinner/LoadingService.js');
require('./common/components/generic-type-pill/GenericTypePill.js');
require('./common/components/status-badge/StatusBadge.js');
require('./common/components/affected-biz-events/AffectedBizEvents.js');
require('./common/components/duration-badge/DurationBadge.js');
require('./common/components/date-badge/DateBadge.js');
require('./common/components/user-badge/UserBadge.js');
require('./common/components/id-badge/IdBadge.js');
require('./common/components/env-badge/EnvBadge.js');
require('./common/components/stat-tile/StatTile.js');
require('./common/components/tabs-stable-height/bmTabsStableHeight.directive.js');
require('./login/AuthService.js');
require('./login/loginController.js');
require('./login/account-recovery/LoginRecoverDialogController.js');
require('./login/reset-password/ResetPasswordController.js');
require('./register/register.js');
require('./activation/AccountActivationController.js');
require('./activation/UserActivationController.js');
require('./home/HomeController.js');
require('./home/user-profile/UserProfileDialogController.js');
require('./home/user-profile/EditProfileDialogController.js');
require('./home/user-profile/UserProfileService.js');
require('./home/user-profile/edit-organization/EditOrganizationDialogController.js');
require('./home/main-menu/datasources/summary/DatasourceDialogController.js');
require('./home/main-menu/data-explorer/DataExplorerDialogController.js');
require('./home/main-menu/datasources/edit-datasource/connection-result/ConnectionResultDialogController.js');
require('./home/main-menu/datasources/edit-datasource/DatasourceEditDialogController.js');
require('./home/main-menu/datasources/edit-datasource/conflict/DatasourceConflictDialogController.js');
require('./home/main-menu/datasources/DatasourceService.js');
require('./home/main-menu/api-collection/ApiCollectionService.js');
require('./home/main-menu/api-collection/ApiCollectionTree.js');
require('./home/main-menu/api-collection/ApiCollectionViewer.js');
require('./home/main-menu/api-collection/ApiCollectionDialogController.js');
require('./home/main-menu/api-collection/create-new/CreateApiCollectionDialogController.js');
require('./common/components/swaggerViewer/swagger-viewer.js');
require('./home/main-menu/api-collection/edit-collection/EditApiCollectionDialogController.js');
require('./home/main-menu/api-collection/swagger-editor/SwaggerEditorDialogController.js');
require('./profile/tabs/template/TemplateTabController.js');
require('./profile/tabs/template/diff/TemplateDiffDialogController.js');
require('./profile/tabs/environments/EnvWorkflowViewer.js');
require('./profile/tabs/environments/EditEnvironmentDialogController.js');
require('./profile/tabs/agents/configuration/AgentConfigService.js');
require('./profile/tabs/agents/logs/AgentLogsService.js');
require('./home/main-menu/agent-panel/AgentsPanelController.js');
require('./home/main-menu/interceptor-panel/InterceptorsPanelController.js');
require('./home/main-menu/users/usersDialogController.js');
require('./home/main-menu/users/tabs/roles-and-permissions/CreateRoleDialogController.js');
require('./home/main-menu/users/tabs/roles-and-permissions/roles-tab-controller.js');
require('./home/main-menu/users/tabs/roles-and-permissions/RolesService.js');
require('./home/main-menu/users/tabs/service-accounts/sa-tab-controller.js');
require('./home/main-menu/users/tabs/user-management/user-list/users-tab-controller.js');
require('./home/main-menu/users/tabs/user-management/create/UserCreateDialogController.js');
require('./home/main-menu/users/tabs/user-management/edit/UserEditDialogController.js');
require('./home/main-menu/users/tabs/user-management/usersService.js');
require('./home/main-menu/users/tabs/service-accounts/ServiceAccount.js');
require('./profile/tabs/agents/download/DownloadDialogController.js');
require('./profile/tabs/agents/logs/LogDetailDialogController.js');
require('./profile/tabs/agents/configuration/AgentConfigDialogController.js');
require('./profile/tabs/agents/logs/AgentLogsDialogController.js');
require('./common/components/agent-status-pill/AgentStatusPill.js');
require('./common/components/packet-distribution-pie/PacketDistributionPie.js');
require('./common/components/capture-upload-bar/CaptureUploadBar.js');
require('./common/components/UserAvatar/UserAvatar.js');
require('./common/components/biz-phone-input/bizFlagUtils.js');
require('./common/components/biz-phone-input/bizPhoneInput.js');
require('./common/components/biz-json-path-selector/BizJsonPathSelector.js');
require('./common/components/biz-json-viewer/BizJsonViewer.js');
require('./common/services/geoLocationService.js');
require('./common/services/TwoFaService.js');
require('./common/components/ip-geo-location/ipGeoLocation.js');
require('./common/components/2fa-validator/TwoFaValidator.js');
require('./common/components/biz-password-input/BizPasswordInput.js');
require('./home/main-menu/users/tabs/user-management/role-picker/RoleExplorerPicker.js');
require('./profile/tabs/agents/TelemetryAgentService.js');
require('./profile/tabs/agents/AgentTabController.js');
require('./profile/tabs/agents/details/agentDetailsDialogController.js');
require('./profile/tabs/agents/download/DownloadService.js');
require('./profile/tabs/agents/stats/AgentStatsDialogController.js');
require('./profile/ProfileService.js');
require('./profile/tabs/clients/ClientService.js');
require('./profile/tabs/clients/create-clients/ClientCreateDialogController.js');
require('./profile/tabs/clients/ClientsTabController.js');
require('./profile/tabs/clients/edit-clients/EditClientDialogController.js');
require('./profile/tabs/resources/ResourceService.js');
require('./profile/tabs/resources/ResourcesTabController.js');
require('./profile/tabs/resources/resource-explorer/ResourceExplorerDialogController.js');
require('./profile/tabs/resources/create-resources/ResourceCreateDialogController.js');
require('./profile/tabs/resources/database-picker/DatabasePickerDialogController.js');
require('./profile/tabs/resources/edit-resources/EditResourceDialogController.js');
require('./profile/tabs/resources/view-record/ViewRecordDetailsDialogController.js');
require('./profile/tabs/resources/import-resources/ImportResourceInstanceDialogController.js');
require('./profile/tabs/biz-events/BizEventsTabController.js');
require('./profile/tabs/biz-events/BusinessEventsService.js');
require('./profile/tabs/biz-events/create-wizard/CreateBizEventWizardController.js');
require('./profile/tabs/biz-events/mapping-step/BizEventMappingStep.directive.js');
require('./profile/tabs/biz-events/edit-mappings/EditBizEventMappingsController.js');
require('./profile/tabs/biz-events/edit-wizard/EditBizEventVersionController.js');
require('./profile/tabs/biz-events/bmel-editor/BmelEditorService.js');
require('./profile/tabs/biz-events/bmel-editor/BmelEditorDialogController.js');
require('./profile/tabs/biz-interceptors/BizInterceptorsTabController.js');
require('./profile/tabs/biz-interceptors/BizInterceptorService.js');
require('./profile/tabs/biz-interceptors/biz-event-picker/BizEventPicker.js');
require('./profile/tabs/biz-interceptors/create-dialog/CreateBizInterceptorDialogController.js');
require('./profile/tabs/biz-interceptors/edit-wizard/EditBizInterceptorDialogController.js');
require('./profile/tabs/biz-interceptors/consolidated-stats-dialog/ConsolidatedStatsDialogController.js');
require('./profile/tabs/biz-interceptors/agent-connection-error-dialog/AgentConnectionErrorDialogController.js');
require('./profile/tabs/biz-interceptors/environment-status-dialog/EnvironmentStatusDialogController.js');
require('./profile/tabs/biz-interceptors/metrics-explorer-dialog/MetricsExplorerDialogController.js');
require('./profile/tabs/biz-interceptors/interceptor-download-dialog/InterceptorDownloadDialogController.js');
require('./profile/profile-details-dialog.controller.js');
require('./home/main-menu/create-profile/create-profile-wizard-controller.js');
require('./referenceData/reference-data-service.js');
require('./template/EditTemplateDialogController.js');
require('./template/frameEdit/EditFrameDialogController.js');
require('./template/TemplateInstanceService.js');
require('./template/linkDataSource/linkDataSourceDialogController.js');
require('./template/tableMapper/TableMapperDialogController.js');
require('./template/treeView/TreeTemplateViewController.js');
require('./template/attributeEdit/ResourceAttributesDialogController.js');
require('./template/importResourceTypes/ImportResourcesTypesDialogController.js');
require('./home/main-menu/notifications/NotificationsService.js');
require('./home/main-menu/notifications/NotificationsDialogController.js');
require('./template/envMappings/envMappingsController.js');
require('./template/jsonPathSelector/jsonPathSelectorDialogController.js');
require('./common/filters.js');
require('./home/main-menu/jobs/jobService.js');
require('./home/main-menu/jobs/JobDefinitionsDialogController.js');
require('./home/main-menu/jobs/JobInstancesDialogController.js');
// Public marketing content is maintained in bizmetry-corporate.

// Dialog styles must be bundled: sibling links in mdDialog templates are not retained.
require("./common/components/ui-security-reactive/ui-security-reactive.css");
require("./common/components/tabs-stable-height/bm-tabs-stable-height.css");
require("./profile/tabs/resources/resources-tab.css");
require("./home/main-menu/data-explorer/data-explorer-dialog.css");
require("./profile/tabs/resources/resource-explorer/resource-explorer-dialog.css");
